import { ITableHeaderProps, Table as TableComponent, TableStyledButton, Td, Tr } from "./Table";

export const Table = Object.assign(TableComponent, {
  Button: TableStyledButton,
  Td,
  Tr
});

export type {
  ITableHeaderProps
};